/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
import {Router} from 'ninelines-router';
import animation from './animation';
import animationSlide from './animationSlide';
import {hideText} from './components/hideText';
import {podcast} from './components/podcast';
import {initVideo} from './components/video-controller';
import helpers from './helpers';
import analytics from './analytics';
import scrollDepth from 'scroll-depth';
import {videoPause, audioPause} from './components/utilits';
import {changeActiveLink, menu} from './components/menu';

const btn = document.querySelectorAll('.intro__slider-button');
const select = document.querySelector('.intro__select select');
let activeslider = false;

const toggleActiveslider = () => {
	activeslider = true;

	setTimeout(() => {
		activeslider = false;
	}, 500);
};

btn.forEach((element) => {
	element.addEventListener('click', (event) => {
		const title = $(event.currentTarget).closest('.page').find('.intro__content-text h2');
		toggleActiveslider();
		setTimeout(() => {
			const name = $(title).text();
			ga('send', 'event', 'main', 'show topic', `${name}`, {nonInteraction: true});
		}, 1500);
	});
});

select.addEventListener('change', toggleActiveslider);

let ybLink = false;
function init() {
	$('.yt__play').on('click', (event) => {
		event.preventDefault();
		const _this = event.currentTarget;
		const overlay = $(_this).closest('.yt').find('.yt__overlay');
		$(overlay).addClass('hide');
		ybLink = $(_this).closest('.yt').find('.yt__video').attr('src');

		$(_this).closest('.yt').find('.yt__video').attr('src', `${ybLink}?autoplay=1&amp`);
	});
	$('[data-link]').on('click', (event) => {
		const target = event.currentTarget.dataset.link;
		const section = document.querySelectorAll(`[data-container="${target}"]`);
		section.forEach((item) => {
			if (!item.closest('.is-hidden')) {
				helpers.scrollTo($(item), 400, -50);
			}
		});
	});

	$('.player').on('click', () => {
		videoPause();
	});

	// introMobile.init();
	podcast();
	hideText();
	initVideo('.home');
	menu();
	changeActiveLink(window.location.pathname + window.location.hash);
	// player.forEach((element) => {
	// 	let audio = new AudioApi(element);
	// 	audio.init();
	// });

	// audioPlayer();
}

setTimeout(() => {
	init();
}, 300);

const router = new Router({
	onEnter(prevState, curState) {
		const hash = window.location.pathname + window.location.hash;
		if (!activeslider) {
			analytics.spentOnPage15sec();
			helpers.setPage(curState.route.name, curState.params.id);
			scrollDepth.reset();
			if (prevState.route) {
				analytics.virtualHit(hash);
			}

			return animation.enter(curState.route.name, curState.params.id);
		}

		return animationSlide.enter(curState.route.name, curState.params.id);
	},

	onLeave(curState) {
		setTimeout(() => {
			audioPause();
			videoPause();
		}, 300);
		if (ybLink) {
			$('.yt__video').attr('src', `${ybLink}`);
		}
		if (curState.route) {
			if (!activeslider) {
				activeslider = false;
				// animationSlide.leave(curState.route.name, curState.params.id, true);
				if (curState.route.name === 'article') {
					return animation.leave(curState.route.name, curState.params.id);
				}

				return animation.leave(curState.route.name);
			}

			return animationSlide.leave(curState.route.name, curState.params.id);
		}

		return Promise.resolve();
	},

	onNotFound() {
		router.navigate('/2');

		return Promise.resolve();
	},

});

router.addRoute({
	path: '/',
	name: 'home',
});

router.addRoute({
	path: '/article/:id',
	name: 'article',
});

router.addRoute({
	path: '/1',
	name: '1',
});

router.addRoute({
	path: '/2',
	name: '2',
});

router.addRoute({
	path: '/3',
	name: '3',
});

router.addRoute({
	path: '/4',
	name: '4',
});

router.addRoute({
	path: '/5',
	name: '5',
});

router.addRoute({
	path: '/6',
	name: '6',
});

router.addRoute({
	path: '/7',
	name: '7',
});


router.addRoute({
	path: '/test',
	name: 'test',
});

router.addRoute({
	path: '/podcasts',
	name: 'podcasts',
});

router.start();

export default router;

